/*
 * @Description: ��̨��ƽ���ѡ��Ͷ�����Ʒ
 */
export default {
	label: 'kdz_goods',
	type: 'kdzgoods',
	property: '',
	value: []
}